import axios from "axios";
import { store } from "../Redux/Store";
import { apiUrl } from "../Utils/Environment";
import showToast from "../Utils/Toast/ToastNotification";
import { userlogout } from "../Redux/Slice/Auth/AuthSlice";
import { navigate } from "../Utils/Navigator";

const axiosInstance = axios.create({
  baseURL: apiUrl,
});

let hasShownInactiveToast = false;

axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();

    const sessionClinicToken = state?.adminSessionAsClinic?.clinic?.token;
    const authToken = state?.auth?.user?.token;
    const token = sessionClinicToken ? sessionClinicToken : authToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (
      response?.status === 401 &&
      response?.data?.message?.toLowerCase().includes("inactive")
    ) {
      if (!hasShownInactiveToast) {
        hasShownInactiveToast = true;
        showToast("error", "Your account has been deactivated by the admin. Please log in again to continue.");
        store.dispatch(userlogout());
        navigate("/login");

        setTimeout(() => {
          hasShownInactiveToast = false;
        }, 3000);
      }
    }

    return Promise.reject(error);
  }
);

export { axiosInstance };
